export default {
    General: 'General',
    'Tax Number': 'Tax Number',
    'Display Name': 'Display Name',
    Phone: 'Phone',
    Email: 'Email',
    'Phone Number': 'Phone Number',
    Agency: 'Agency',
    Code: 'Code',
    'AMF Code': 'AMF Code',
    'AMF Username': 'AMF Username',
    'AMF Password': 'AMF Password',
    System: 'System',
    'Created On': 'Created On',
    'System Entity': 'System Entity',
    Actions: 'Actions',
    'Balance LCY': 'Balance LCY',
    'Due Balance LCY': 'Due Balance LCY',
    'Commission to Month': 'Commission to Month',
    Serial: 'Serial',
    'Insurance Sector Type': 'Insurance Sector Type',
    'Issued Date': 'Issued Date',
    'Start Date': 'Start Date',
    'From the date': 'From the date',
    'Until the date': 'Until the date',
    'Prime aggregation only for active police': 'Prime aggregation only for active police',
    'Primes for each department': 'Primes for each department',
    'The client has no prime in the system!': 'The client has no prime in the system!',
    'Status Type': 'Status Type',
    'Premium Gross': 'Premium Gross',
    'Premium Net': 'Premium Net',
    Underwriter: 'Underwriter',
    Intermediary: 'Intermediary',
    'Product Code': 'Product Code',
    'Product Name': 'Product Name',
    Currency: 'Currency',
    'Agency Commission Rate': 'Agency Commission Rate',
    Agent: 'Agent',
    'Bonus Commission Rate': 'Bonus Commission Rate',
    Leader: 'Leader',
    Customer: 'Customer',
    'Owner %': 'Ownership Percentage %',
    'Invoice %': 'Invoice %',
    Name: 'Name',
    'Contact Type': 'Contact Type',
    Checked: 'Checked',
    Coverage: 'Coverage',
    Mandatory: 'Mandatory',
    Premium: 'Premium',
    'Sum Insured': 'Sum Insured',
    'The Deductible Part': 'The Deductible Part',
    Franchize: 'Franchize',
    'Event Based Limits': 'Event Based Limits',
    'Person Based Limits': 'Person Based Limits',
    'Period Based Limits': 'Period Based Limits',
    'Special Coverage': 'Special Coverage',
    Local: 'Local',
    Country: 'Country',
    City: 'City',
    'Postal Code': 'Postal Code',
    'Street Address': 'Street Address',
    'Street Address 2': 'Street Address 2',
    'Insured Amount': 'Insured Amount',
    Id: 'ID',
    Comment: 'Comment',
    Date: 'Date',
    'Created By': 'Created By',
    'Total Limit': 'Total Limit',
    Order: 'Order',
    Amount: 'Amount',
    Description: 'Description',
    'Nr.': 'Nr.',
    'End Date': 'End Date',
    'Customer Name': 'Customer Name',
    'Owner Name': 'Owner Name',
    'Permit Number': 'Permit Number',
    Vehicle: 'Vehicle',
    Vin: 'Vin',
    Plate: 'Plate',
    Classification: 'Classification',
    Make: 'Make',
    Model: 'Model',
    Power: 'Power',
    Region: 'Region',
    Fuel: 'Fuel',
    Year: 'Year',
    Type: 'Type',
    Volume: 'Volume',
    Seats: 'Seats',
    Color: 'Color',
    Obligations: 'Obligations',
    'We to the customer': 'We to the customer',
    'The customer to us': 'The customer to us',
    Details: 'Details',
    Birthday: 'Birthday',
    Hospital: 'Hospital',
    Website: 'Website',
    Notes: 'Notes',
    'Hospital Type': 'Hospital Type',
    'Tax Rate': 'Tax Rate',
    Commissions: 'Commissions',
    'Agent Commission Rate': 'Agent Commission Rate',
    'Bonus Commission Rate Cap': 'Bonus Commission Rate Cap',
    'AMF Contribution Rate': 'AMF Contribution Rate',
    'Dynamic Durations': 'Dynamic Durations',
    Group: 'Group',
    Default: 'Default',
    Years: 'Years',
    Months: 'Months',
    Days: 'Days',
    'Stock Id': 'Stock Id',
    'Serial Start': 'Serial Start',
    'Serial End': 'Serial End',
    'Total Serials': 'Total Serials',
    'Customer Policies': 'Customer Policies',
    'Agency Policies': 'Agency Policies',
    'Agent Policies': 'Agent Policies',
    'All Policies': 'All Policies',
    'Draft Policies': 'Draft Policies',
    'Issued Policies': 'Issued Policies',
    'Archived Policies': 'Archived Policies',
    Motor: 'Motor',
    Quantity: 'Quantity',
    Branch: 'Branch',
    Summary: 'Summary',
    Generals: 'Generals',
    'Base Coverage': 'Base Coverage',
    'First Coverage': 'First Coverage',
    'Second Coverage': 'Second Coverage',
    'Third Coverage': 'Third Coverage',
    'Fourth Coverage': 'Fourth Coverage',
    Number: 'Number',
    Property: 'Property',
    Marine: 'Marine',
    'Selected Coverages': 'Selected Coverages',
    'Selected Articles': 'Selected Articles',
    'Article Type': 'Article Type',
    'Numri i policave te shitura': 'Numri i policave te shitura',
    'Primet totale - ALL': 'Primet totale - ALL',
    'Primet totale - EUR': 'Primet totale - EUR',
    'Open Details': 'Open Details',
    'Open Risk Addresses': 'Open Risk Addresses',
    'Fill Form': 'Fill Form',
    'Open Agencies': 'Open Agencies',
    'UXH Status': 'UXH Status',
    'Policy Agent': 'Policy Agent',
    'Sales Agent': 'Sales Agent',
    'Identifier 1': 'Identifier 1',
    'Identifier 2': 'Identifier 2',
    'Identifier 3': 'Identifier 3',
    'Min Premium': 'Min Premium',
    'Blocked Type': 'Blocked Type',
    'Iosa Id': 'Iosa Id',
    '...': '...',
    'Cancellation Reason': 'Cancellation Reason',
    'Cancelled By': 'Cancelled By',
    Global: 'Global',
    Duplicate: 'Duplicate',
    'Premium Adjustment': 'Premium Adjustment',
    'Bank Transaction Id': 'Bank Transaction Id',
    'AMF Report Code': 'AMF Report Code',
    'The Insured': 'The Insured',
    'The Insured (Tax Number)': 'The Insured (Tax Number)',
    'Related Agency Code': 'Related Agency Code',
    'Agency Code': 'Agency Code',
    'Premium Calculated': 'Premium Calculated',
    'Maximum Coverage Amount': 'Maximum Coverage Amount',
    'Insured Object': 'Insured Object',
    'List of insured objects': 'List of insured objects',
    'Risk Address': 'Risk Address',
    'Cancellation Date': 'Cancellation Date',
    Client: 'Client',
    Renewals: 'Renewals / Installments',
    Identifier: 'Identifier',
    Citizenship: 'Citizenship',
    'Installment Date': 'Installment Date',
    'Number of installments': 'Number of installments',
    Installments: 'Installments',
    'Insured Sum': 'Insured Sum',
    'Number of renewals': 'Number of renewals',
    Driver: 'Driver',
    Role: 'Role',
    'Policy User': 'Policy User',
    'Extra Fee': 'Extra Fee',
    'Risk Addresses': 'Risk Addresses',
    AccountType: 'Account Type',
    Account: 'Account',
    SystemDescription: 'System Description',
    AccountMonetary: 'Account Monetary',
    Balance: 'Balance',
    ExchangeRate: 'Exchange Rate',
    BalanceLCY: 'Balance ALL',
    DebitValue: 'Debit Value',
    CreditValue: 'Credit Value',
    Value: 'Value',
    ValueLCY: 'Value LCY',
    NewBalance: 'New Balance',
    NewBalanceLCY: 'New Balance ALL',
    Note: 'Note from System',
    'Nr. ERP': 'No. ERP',
    'Nr. Serial Polica': 'No. Policy Series',
    'Dt. Fatures': 'Invoice Date',
    'Dt. Krijimi Fatures': 'Invoice Create Date',
    'Klient Tax Id': 'Client Tax Id',
    'Klient Lloji': 'Client Category',
    'Klient Emri': 'Client Name',
    'No.': 'No.',
    Pershkrim: 'Description',
    Monedha: 'Currency',
    Kursi: 'Exchange',
    Vlera: 'Value',
    'Vlera ALL': 'Value ALL',
    FISKALIZUAR: 'FISCALIZED',
    Invoices: 'Invoices',
    'Start Date Range': 'Start Date Range',
    'Issue Date Range': 'Issue Date Range',
    'Dates Configurations': 'Dates Configurations',
    'Can Sell': 'Can Sell',
    'Can Cancel': 'Can Cancel',
    'Can Return': 'Can Return',
    'Can Duplicate': 'Can Duplicate',
    'Can Adjust Premium': 'Can Adjust Premium',
    'Has Installments': 'Has Installments',
    'Has Renewals': 'Has Renewals',
    Beneficiaries: 'Beneficiaries',
    'Policy Holders': 'Policy Holders',
    'Policy Users': 'Policy Users',
    'Invoice Recipient': 'Invoice Recipient',
    Participants: 'Participants',
    'Types Allowed': 'Types Allowed',
    'The reason for the failure': 'The reason for the failure',
    'The number of bank branches': 'The number of bank branches',
    'Modifikim fature': 'Modifikim fature',
    'Ndrysho faturimin': 'Ndrysho faturimin',
    'Insurer Display Name': 'Insurer Name',
    'Territorial Coverage': 'Territorial Coverage',
    'Dt. Fillimit': 'Start Date',
    'Dt. Mbarimit': 'End Date',
    'Product Template': 'Product Template',
    'Beneficiary Display Name': 'Beneficiary Display Name',
    'Beneficiary Tax Number': 'Beneficiary Tax Number',
    'Beneficiary Display Name 2': 'Beneficiary Display Name 2',
    'Beneficiary Tax Number 2': 'Beneficiary Tax Number 2',
    'PolicyHolder Display Name': 'PolicyHolder Display Name',
    'PolicyHolder Tax Number': 'PolicyHolder Tax Number',
    'Coverage Display Name List': 'Coverage Name',
    Sublimits: 'Services',
    Rates: 'Rates',
    'Select product': 'Select product',
    'Select product & template': 'Select product & template',
    'Select agency': 'Select agency',

    'Work status': 'Work status',
    Roles: 'Roles',
    Koeficenti: 'Koeficenti',
    'Data e praktikes': 'Data e praktikes',
    'Data e njoftimit': 'Data e njoftimit',
    'Lloji i demit': 'Lloji i demit',
    'Total Value': 'Total Value',
    Card: 'Card',
    'Status Updated By': 'Status Updated By',
    'Status Updated Date': 'Status Updated Date',
    'Status Updated Reason': 'Status Updated Reason',
    'Custom Limit': 'Custom Limit',
    Billed: 'Billed',
    Pay: 'Pay',
    Debit: 'Debit',
    'Agency Name': 'Agency Name',
    Comments: 'Comments',
    'Sub Services': 'Sub Services',
    'Nen sherbimet': 'Nen sherbimet',
    'Number of Insured Objects': 'Number of Insured Objects',
    'Lloji i personit': 'Lloji i personit',
    'Paid Amount LCY': 'Paid Amount Gross ALL',
    'Paid Amount': 'Paid Amount',
    Select: 'Select',
    'Search Agency': 'Search Agency',
    'Search Customer': 'Search Customer',
    'Search Policy Serial': 'Search Policy Serial',
    'Projected Total': 'Projected Total',
    'Selekto pagesen per editim': 'Select a payment to edit',
    'Fisc UblId': 'Fisc UblId',
    'Posted On': 'Posted On',
    'Amount LCY': 'Amount LCY',
    'Can Edit Template': 'Can Edit Template',
    'Payable Within': 'Payable Within',
    'Continuity Date': 'Continuity Date',

    'Action Type': 'Action Type',
    'Status Note': 'Status Note',
    Source: 'Source',
    'IOSA ID': 'IOSA ID',
    'Created At': 'Created At',
    'Updated At': 'Updated At',
    'Updated By': 'Updated By',
    'Policy Serial': 'Policy Serial',
    Paid: 'Paid',
    Nr: 'Nr',
    'Loading Date': 'Loading Date',
    Sender: 'Sender',
    'Sender NUIS': 'Sender NUIS',
    Receiver: 'Receiver',
    'Receiver NUIS': 'Receiver NUIS',
    'Cargo Description': 'Cargo Description',
    Weight: 'Weight',
    'Vehicle Plate': 'Vehicle Plate',
    'Trailer Plate': 'Trailer Plate',
    'Loading Country': 'Loading Country',
    'Loading City': 'Loading City',
    'Loading Address': 'Loading Address',
    'Delivery Country': 'Delivery Country',
    'Delivery City': 'Delivery City',
    'Delivery Address': 'Delivery Address',

    'Channel Type': 'Channel Type',
    'Scope Type': 'Scope Type',
    'Normalized Value': 'Normalized Value',
    Active: 'Active',
    Reason: 'Reason',
    'Related Policies': 'Related Policies',
    'Cross Sell': 'Cross Sell',
    'Cross Sell / Inherited Participants': 'Cross Sell / Inherited Participants',
    'Coverage Period': 'Coverage Period',
    Version: 'Version',
};
